import { render, staticRenderFns } from "./UnivaPayEditor.vue?vue&type=template&id=8020b152&scoped=true&"
import script from "./UnivaPayEditor.vue?vue&type=script&lang=ts&"
export * from "./UnivaPayEditor.vue?vue&type=script&lang=ts&"
import style0 from "./UnivaPayEditor.vue?vue&type=style&index=0&id=8020b152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8020b152",
  null
  
)

export default component.exports